import React from 'react'
import styles from './ResourceList.scss'
import PropTypes from 'prop-types'
import { classNames } from './../../utils/styles'
import Item from './Item'

export default class ResourceList extends React.Component {
  static Item = Item
  static propTypes = {
    items: PropTypes.array,
    equalWidthActions: PropTypes.bool,
    renderItem: PropTypes.func,
  }

  renderResourceListItem = (item, index) => {
    const { renderItem } = this.props
    const id = item.hasOwnProperty('id') ? item.id : index.toString()
    return (
      <li key={id} className={styles.ItemWrapper}>
        {renderItem(item, index)}
      </li>
    )
  }

  render() {
    const { items, equalWidthActions } = this.props
    const itemsExist = items.length > 0

    const listMarkup = itemsExist ? (
      <ul className={classNames(styles.ResourceList, equalWidthActions && styles['ResourceList--equalWidthActions'])}>
        {items.map(this.renderResourceListItem)}
      </ul>
    ) : null

    return <div className={styles.Wrapper}>{listMarkup}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/ResourceList/index.js